import * as API from '@siloreal:shared:api';

const LAB_PROTOCOL_TEMPLATES_ENDPOINT = '/lab/protocols/export/getTemplatesBySilobags';

export type LabProtocolTemplateTranslation = {
  id: number;
  lab_template_id: number;
  language_id: number;
  description: string;
};

export type LabProtocolSpeciesTranslation = {
  id: number;
  silobag_species_type_id: number;
  language_id: number;
  description: string;
};

export type LabProtocolSpecies = {
  id: number;
  name: string;
  image_url: string;
  silobag_species_types_translations: LabProtocolSpeciesTranslation[];
};

export type LabProtocolTemplate = {
  id: number;
  internal_name: string;
  is_master_template: boolean;
  version: number;
  organization_id: number;
  silobag_species_type_id: number;
  silobag_species_type: LabProtocolSpecies;
  lab_templates_determinations: unknown[];
  lab_templates_translations: LabProtocolTemplateTranslation[];
};

export type LabProtocolTemplateGroup = {
  description: string;
  silobags: string[];
  silobag_species_type_id: number;
  lab_templates: LabProtocolTemplate[];
};

export type ListLabProtocolTemplatesResponse = {
  lab_grouped_silobag_by_specie_type: LabProtocolTemplateGroup[];
  silobag_species_types_with_lab_templates: LabProtocolSpecies[];
};

export type ListLabProtocolTemplatesServiceContract = {
  silobagIds: readonly string[];
  signal?: AbortSignal;
};

export async function listLabProtocolTemplatesService(
  contract: ListLabProtocolTemplatesServiceContract
): Promise<ListLabProtocolTemplatesResponse> {
  const { data } = await API.http.fetch.post<ListLabProtocolTemplatesResponse>(
    LAB_PROTOCOL_TEMPLATES_ENDPOINT,
    {
      body: { silobags: contract.silobagIds },
      signal: contract.signal,
    }
  );

  return data;
}
